<template>
  <div class="dialog-wrap">
    <el-dialog
      title="内容版块编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="版块标题"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入版块标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="副标题"
          prop="subtitle"
        >
          <el-input
            v-model="dataForm.subtitle"
            placeholder="请输入版块副标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="版块位置"
          prop="site"
        >
          <el-select
            v-model="dataForm.site"
            placeholder="请选择版块位置"
            style="width: 100%;"
          >
            <el-option
              v-for="item in sites"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容类型"
          prop="type"
        >
          <el-select
            v-model="dataForm.type"
            placeholder="请选择内容类型"
            style="width: 100%;"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="布局方向"
          prop="layout"
        >
          <el-select
            v-model="dataForm.layout"
            placeholder="请选择布局方向"
            style="width: 100%;"
          >
            <el-option
              v-for="item in layouts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="跳转链接"
          prop="link_url"
        >
          <el-input
            v-model="dataForm.link_url"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop="sort"
        >
          <el-input
            v-model="dataForm.sort"
            placeholder="请输入排序值，纯数字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="在线状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sectionUpdate } from '@/api/section'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      types: [
        { label: '课程', value: 1 },
        { label: '题库', value: 2 },
        { label: '阅读资料', value: 3 },
        { label: '实体资料', value: 4 }
      ],
      sites: [
        { label: '首页', value: 1 },
        { label: '院校页', value: 2 },
        { label: '课程页', value: 3 },
        { label: '题库页', value: 4 },
        { label: '调剂推荐页', value: 5 }

      ],
      layouts: [
        { label: '横向', value: 'row' },
        { label: '纵向', value: 'column' }
      ],
      rules: {
        title: [{ required: true, message: '请输入版块标题', trigger: 'blur' }],
        site: [{ required: true, message: '请选择版块位置', trigger: 'change' }],
        type: [{ required: true, message: '请选择推荐类型', trigger: 'change' }],
        layout: [{ required: true, message: '请选择布局方向', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            title: this.dataForm.title,
            subtitle: this.dataForm.subtitle,
            type: this.dataForm.type,
            site: this.dataForm.site,
            layout: this.dataForm.layout,
            link_url: this.dataForm.link_url,
            sort: this.dataForm.sort,
            layout: this.dataForm.layout,
            status: this.dataForm.status ? 1 : 0
          }
          sectionUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
